import React, { Component } from 'react';
import 'HELPDESK/Components/ModuleCertification/CertificateDetails/CertificateDetails.css';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import DeleteTextModal from 'HELPDESK/CommonResources/DeleteTextModal/DeleteTextModal';
import ReactToPrint from 'react-to-print';

class CertificateDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //VARIABLES TO SHOW CONTENT LIST
            certificateDetailsFetching:false,
            contentList: {},
            totalPoints:0,
            moduleName:"",
            approvedPoint:0,
            percentage:0,
            font_awesome_icon:'',
            collapsedContentIdArray: [],

            //VARIABLES TO ADD CONTENT RESPONSE           
            addingResponse:false,
            selectedContentId:'',
            contentURL:'',
            contentURLWarning:'',
            remark:'',
            remarkWarning:'',
            showVideoCreation:false,

            //variables to edit language
            UpdateSelectedLanguageArray:this.props.UpdateSelectedLanguageArray,
            selectedLanguageArray:this.props.selectedLanguageArray,
            selectedLanguage:[],
            certificationAvailableLanguage:["English","Hindi","Marathi","Telugu","Kannada","Malayalam"],
        };
    }

    componentDidMount() {
        if(this.state.UpdateSelectedLanguageArray)
        {
            this.setState({
                selectedLanguage:this.state.selectedLanguageArray
            })
        }
       // API CALL METHOD TO GET CERTIFICATE DETAILS
       this.apiCallToGetCertificateDetails();
    }

    // API CALL METHOD TO GET CERTIFICATE DETAILS
    apiCallToGetCertificateDetails = async () => {
        this.setState({
            certificateDetailsFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "moduleId":this.props.certificationModuleId,
            "certificationId":this.props.certificationId
            // "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskCertificationContentList',
            requestData,
            '/api/helpDesk/employee/moduleCertification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetCertificateDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let totalPoints = apiResult.totalPoints;
                let approvedPoints = apiResult.approvedPoint;
                let percentage = 0;
                if(totalPoints>0 && approvedPoints>0 )
                {
                    percentage = (approvedPoints/totalPoints)*100;
                }
                
                this.setState({
                    certificateDetailsFetching: false,
                    contentList: apiResult.data,
                    totalPoints:apiResult.totalPoints,
                    moduleName:apiResult.moduleName,
                    approvedPoint:apiResult.approvedPoint,
                    percentage:percentage,
                    font_awesome_icon:apiResult.font_awesome_icon
                    
                });
            } else {
                this.setState({
                    certificateDetailsFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting certification details. Please try again later.'
                });
            }
        }
    }
    
    //METHOD TO SAVE COLLAPSED CONTENT ID
    collapseContent = (content) =>{
       
        let collapsedContentIdArray = this.state.collapsedContentIdArray;
        if(collapsedContentIdArray.includes(content.pointId))
        {
            collapsedContentIdArray = collapsedContentIdArray.filter(id => id != content.pointId);
        }else{
            collapsedContentIdArray.push(content.pointId);   
        }
        this.setState({
            collapsedContentIdArray
        })
    }

    
    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    // METHOD TO SET URL
    setURL = (e) => {
        this.setState({
            contentURL: e.target.value
        });
        if(e.target.value.length < 1) {
            this.setState({
                contentURLWarning: 'Please enter URL.',
               
            });
        }else {
            this.setState({
                contentURLWarning: '',
            });
        }
    }
    // METHOD TO SET REMARK
    setRemark = (e) => {
        this.setState({
            remark: e.target.value
        });
        if(e.target.value.length < 1) {
            this.setState({
                remarkWarning: 'Please enter Remark.',
               
            });
        }else {
            this.setState({
                remarkWarning: '',
            });
        }
    }
    // METHOD TO VALIDATE CERTIFICATION DETAILS
    validateResponseDetails = () => {
        let validData = true;
     
        if(this.state.contentURL.length < 1) {
            this.setState({
                contentURLeWarning: 'Please enter URL.'
            });
            validData = false;
        }  

        // if(this.state.remark.length < 1) {
        //     this.setState({
        //         remarkWarning: 'Please enter Remark.'
        //     });
        //     validData = false;
        // }
        if(validData) {
            // METHOD CALLED TO ADD CERTIFICATE
            this.apiCallToAddResponse();
        }
    }

    // API CALL METHOD TO ADD CERTIFICATE
    apiCallToAddResponse = async () => {
        this.setState({
            addingResponse: true
        });

        let requestData = {
            "iid": config.institute_id,
            "module_id": this.props.certificationModuleId,
            "certificate_id": this.props.certificationId,
            "facultyId": config.faculty_id,
            "content":this.state.contentURL,
            "remark": this.state.remark,
            "demo_point_id":this.state.selectedContentId,
            "userRole":"Instructor",
            "status":"Pending"
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'AddHelpDeskCertificationContentResponse',
            requestData,
            '/api/helpDesk/employee/moduleCertification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddResponse()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    let contentList = this.state.contentList;
  
                    if(contentList[this.state.selectedContentId] != undefined) {
                        
                        if(contentList[this.state.selectedContentId]["responses"][apiResult.UID] == undefined) 
                        { 
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID] = {};
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID]["status"] = "Pending";
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID]["contentUid"] = apiResult.UID;
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID]["content"] = this.state.contentURL;
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID]["remark"] = this.state.remark;
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID]["userId"] = config.faculty_id;                            
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID]["userRole"] = "Instructor";
                            contentList[this.state.selectedContentId]["responses"][apiResult.UID]["contentAdded_on"] = apiResult.contentAdded_on;
                        }
                    }
                 
                    
                    this.setState({
                        addingResponse: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        contentList,                
                    });
                    this.closeAddCertificateResponse();
                }else {
                    this.setState({
                        addingResponse: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    coordinatorFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding certificate. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE ADD COORDINATOR
    closeAddCertificateResponse = () => {
        this.setState({
            addingResponse: false,
            contentURL:'',            
            contentURLWarning:'',
            remarkWarning:'',
            remark:'',
            selectedContentId:'',
        });
    }


    //FUNCTION TO RETURN VIDEO CREATION INSTRUCTIONS
    returnVideoCreation = () => {
        return(
            <div className={this.state.showVideoCreation ? "modal fade show in" : "modal fade"} id="showVideoCreationModel" tabIndex="-1" role="dialog" aria-labelledby="showVideoCreationModelLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content filterCommittee-content">
                        <div className="modal-header filterCommittee-header" style={{borderBottom:0}}>
                            <h5 className="modal-title filterCommittee-title" id="showVideoCreationModelLabel">
                                How to a create  a video URL for the review ? 
                                <button type="button" style={{paddingLeft:10}} class="close" onClick={()=>this.setState({showVideoCreation:false})}>
                                    <span aria-hidden="true">&times;</span>                                
                                </button>
                            </h5>
                        </div>
                        <div className="modal-body container-fluid" style={{fontSize:12}}>
                            <div>
                                <div style={{fontWeight:"bold"}}>Guidelines while creating video</div>
                                <ol>
                                    <li>Audio should be clear.</li>
                                    <li>Maintain professionalism during recording. </li>
                                    <li>Be in formal attire.</li>
                                    <li>You need to record the training video on Laptop/Desktop only.</li>
                                    <li>Try to cover the specified content while recording the video</li>
                                    <li>Keep proper distance while recording the video.</li>
                                </ol>
                                <br/><br/>
                                <div>
                                    <span style={{fontWeight:"Bold",marginRight:10}}>Step 1 : </span>
                                    <span style={{color:"#4A4B57"}}>Create a folder in Drive. (e.g Google drive, One drive etc)</span>
                                </div>
                                <div>
                                    <span style={{fontWeight:"Bold",marginRight:10}}>Step 2 : </span>
                                    <span style={{color:"#4A4B57"}}>Upload your videos in that folder.</span>
                                </div>
                                <div>
                                    <span style={{fontWeight:"Bold",marginRight:10}}>Step 3 : </span>
                                    <span style={{color:"#4A4B57"}}>Create a public link of that folder.</span>
                                </div>
                                <div className="publicLink">
                                    <div style={{fontWeight:"bold",marginRight:10}}>How to create public link? </div>
                                    <ol>
                                        <li>On your computer, go to drive.google.com.</li>
                                        <li>Click the folder you want to share.</li>
                                        <li>Under "People," type the email address or Google Group you want to share with.</li>
                                        <li>To choose how a person can use the folder, click the Down arrow.</li>
                                        <li>Try to cover the specified content while recording the video</li>
                                        <li> Click Send.</li>
                                    </ol>
                                </div>
                                <div>
                                    <span style={{fontWeight:"Bold",marginRight:10}}>Step 4 : </span>
                                    <span style={{color:"#4A4B57"}}>Paste that link in the mentioned placeholder.</span>
                                </div>
                                <div>
                                    <span style={{fontWeight:"Bold",marginRight:10}}>Step 5 : </span>
                                    <span style={{color:"#4A4B57"}}>Submit the link for the review.</span>
                                </div>
                                <div className="col-md-12 videoNote">
                                    <div style={{fontWeight:"bold"}}>Note:</div>
                                    <div className="col-md-12">
                                        <ul>
                                            <li>The link should be same for 90 days. Once approved you may remove or change it.</li>
                                            <li>You need to complete the certification within 15-30 days.</li>
                                            <li>The validity of certificate is 1 year.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        );
    }

    substringString =(language,stringLength) =>{
        return language.length > stringLength ? language.substring(0,stringLength)+"...":language;
    }

    // METHOD TO SELECT Language
    selectUpdateCertificationLanguage = (language) => {
     
        let selectedLanguage = this.state.selectedLanguage;

        if(selectedLanguage.includes(language)) {
            selectedLanguage = selectedLanguage.filter(name => name != language);
        }else {
            selectedLanguage.push(language);
        }
        if(selectedLanguage.length<1)
        {
            this.setState({
                languageWarning: 'Please select language.',
            })
        }else{
            this.setState({
                languageWarning: '',
            })
        }

        this.setState({
            selectedLanguage
        });
    }

    // METHOD TO VALIDATE CERTIFICATION DETAILS
    validateCertificationDetails = () => {
        let validData = true;
        

        if(this.state.selectedLanguage.length < 1) {
            this.setState({
                languageWarning: 'Please select language.'
            });
            validData = false;
        }
        if(validData) {
            // METHOD CALLED TO Update CERTIFICATE
            this.apiCallToUpdateCertificate();
        }
    }


    // API CALL METHOD TO Update CERTIFICATE
    apiCallToUpdateCertificate = async () => {
        this.setState({
            updatingCertificate: true
        });

        let requestData = {
            "iid": config.institute_id,
            "module_id": this.state.moduleId,
            "certification_language_array": this.state.selectedLanguage,
            "facultyId": config.faculty_id,
            "moduleCertificationId":this.state.certificationId
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'UpdateHelpDeskModuleCertification',
            requestData,
            '/api/helpDesk/employee/moduleCertification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateCertificate()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    // let coordinatorList = this.state.coordinatorList;
                    // let moduleList = this.state.moduleList;
                    // let employeeList = this.state.employeeList;
                    // if(coordinatorList[this.state.selectedModule] == undefined) {
                    //     coordinatorList[this.state.selectedModule] = {};
                    //     coordinatorList[this.state.selectedModule]["moduleId"] = this.state.selectedModule;
                    //     coordinatorList[this.state.selectedModule]["moduleName"] = moduleList[this.state.selectedModule]["module_name"];
                    //     coordinatorList[this.state.selectedModule]["coordinatorObj"] =[];
                    // }
                 
                    
                    this.setState({
                        updatingCertificate: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        showCertificationContent:true,     
                        selectedLanguageArray:this.state.selectedLanguage
                                   
                    });
                    this.closeUpdateCertificate();
                }else {
                    this.setState({
                        updatingCertificate: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    coordinatorFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding certificate. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE ADD COORDINATOR
    closeUpdateCertificate = () => {
        this.setState({
            updatingCertificate: false,
            moduleId:'',            
            moduleWarning:'',
            languageWarning:'',
            selectedLanguage:[],

        });
    }

    render() {
        return (
            <>
                {
                    this.state.certificateDetailsFetching ? 
                        <ButtonLoader/>
                    :
                        <>
                        <div className="col-md-12" style={{display:"flex",padding:0}}>
                            <div className="col-md-5 " style={{paddingRight:0}}>
                                    <div className="certificationHeader">
                                        <span className="certificationHeaderIcon">
                                            <FontAwesomeIcon  icon={['fas', this.state.font_awesome_icon]} />
                                        </span>
                                        <span style={{fontWeight:"bold"}}>{this.state.moduleName}</span>
                                        <span className={this.state.percentage == 100 ? " statusBadge badge bg-success": " statusBadge badge bg-warning" }>{this.state.percentage == 100 ? "Completed": "In-progress"}</span>
                                    </div>
                            </div>
                            <div className="col-md-5" >
                                    <div className="certificationHeader" title={this.state.selectedLanguageArray.join(", ")}>
                                       {
                                           this.state.UpdateSelectedLanguageArray ? 
                                           <>
                                                <div className="addCertificationLanguage" style={{marginTop:10}}>
                                                    <div className="dropdown">
                                                        <input
                                                            type="text"
                                                            className="form-control addQueryInput"
                                                            placeholder='Click to select language'
                                                            data-toggle="dropdown"
                                                            readOnly
                                                        />
                                                        <div id="languageDropdown" className="dropdown-menu">
                                                            {                                          
                                                                this.state.certificationAvailableLanguage.map(language => {
                                                                    return (
                                                                        <p className="dropdown-item languageItem" style={{ display: 'flex' }} key={language} onClick={() => this.selectUpdateCertificationLanguage(language)}>
                                                                            <input
                                                                                type='checkbox'
                                                                                checked={this.state.selectedLanguage.includes(language)}
                                                                                style={{ marginRight: 10 }}
                                                                            />
                                                                            <span>{language}</span>
                                                                        </p>
                                                                    );
                                                                })                                            
                                                            }
                                                        </div>
                                                        <span style={{'font-size':'13px'}}>{this.state.selectedLanguage.join(', ') }</span>
                                                    </div>
                                                    <p className="text-danger" style={{ fontSize: 14 }}>{this.state.languageWarning}</p>
                                                </div>
                                                <div>
                                                    <FontAwesomeIcon icon={['fas', 'check']} color="#219653" style={{ marginRight: 5, cursor: 'pointer' }} title="Click to update certificate" onClick={(e) => this.state.updatingCertificate ? e.preventDefault() : this.validateCertificationDetails()} />
                                                    <FontAwesomeIcon icon={['fas', 'times']} color="#EB5757" style={{ cursor: 'pointer' }} title="Click to cancel updating certificate" onClick={() => this.closeUpdateCertificate()} />
                                                   
                                                </div>
                                           </>
                                           :
                                           <>{this.substringString(this.state.selectedLanguageArray.join(", "),50)}</>
                                       }
                                    </div>
                            </div>
                            <div className="col-md-2" >
                                    <div className="certificationHeader">
                                        <span style={{color:"#787885"}}>Progress {this.state.percentage}%</span>
                                    </div>
                            </div>
                        </div> 
                        <div className="col-md-12 ">
                                <div className="certificationBody">
                                    <span style={{fontWeight:"bold",marginTop:10}}>Training Content</span>
                                    <div className="contentList">
                                        {
                                            Object.values(this.state.contentList).length > 0 &&
                                                Object.values(this.state.contentList).map((content,contentIndex) => {
                                                    return(
                                                        <div className="contentContainer" style={{borderLeft:content.status == "Approved" ? "2px solid green" :"2px solid orange"}}>
                                                            <div className="Content">
                                                                <div className="serialNo"><span className="NumberSpan">{contentIndex+1}</span></div>
                                                                <div className="Point">
                                                                    {ReactHtmlParser(content.point)}
                                                                    <div className="addResponseContainer">                                                                
                                                                        {
                                                                            Object.values(content.responses).length > 0 &&
                                                                            Object.values(content.responses).map((response,responseIndex) => {
                                                                                
                                                                                return(
                                                                                    <>
                                                                                    {
                                                                                        (responseIndex == 0 || this.state.collapsedContentIdArray.includes(content.pointId)) &&                                                                               
                                                                                            <div className="responseContainer" key={response.contentUid}>
                                                                                                
                                                                                                {
                                                                                                    
                                                                                                    response.userRole == "Instructor" ? 
                                                                                                        <div className="UserIconHolder">
                                                                                                        {
                                                                                                            config.FirstName.substring(0,1)+""+config.LastName.substring(0,1)
                                                                                                        }
                                                                                                        </div>
                                                                                                    :
                                                                                                        <div className="VmIconHolder">
                                                                                                            VM
                                                                                                        </div>
                                                                                                }
                                                                                        
                                                                                            <div className="ResponseAddedOn">{response.contentAdded_on}</div>
                                                                                            <div className="ResponseContent">
                                                                                                <div style={{fontWeight:"bold"}}>Video URL</div>
                                                                                                <div style={{color:"#0465AC"}}>{response.content}</div>
                                                                                                <div style={{fontWeight:"bold"}}>Remark</div>
                                                                                                <div >{response.remark}</div>
                                                                                            </div>
                                                                                            <div className="responseStatus">{
                                                                                                response.userRole !="Instructor" &&
                                                                                                <span className={response.status == "Approved" ? " statusBadge badge bg-success": " statusBadge badge bg-warning" }>{response.status}</span>
                                                                                            }</div>
                                                                                        </div>
                                                                                    }
                                                                                    </>
                                                                                    
                                                                                )
                                                                            })
                                                                        }
                                                                            
                                                                        {
                                                                            content.status != "Approved" &&
                                                                            <>
                                                                            {

                                                                                this.state.selectedContentId != content.pointId ? 
                                                                                <>                                                                        
                                                                                    <div className="btn responseBtn" style={{backgroundColor:"#2979FF",color:"#ffffff"}} onClick = {()=> this.setState({selectedContentId:content.pointId})}>Add Your Response</div>
                                                                                </>
                                                                                :<div className="responseContentInput">
                                                                                    <div className="urlInputDiv">
                                                                                        <span>Video URL <span style={{color:"red"}}>* </span><span style={{color:"#007bff",cursor:"pointer"}} onClick={()=>this.setState({showVideoCreation:true})}>How to create a Video URL for the review ?</span></span>
                                                                                        <div>
                                                                                            <input type="text" maxLength={100} className="form-control addQueryInput" placeholder='Add Video URL' value={this.state.contentURL} onChange={(e) => this.setURL(e)} />
                                                                                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.contentURLeWarning}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="remarkInputDiv">
                                                                                        <span>Remark (If any)</span>
                                                                                        <div>
                                                                                            <input type="text" maxLength = {250} className="form-control addQueryInput" placeholder='Add Remark' value={this.state.remark} onChange={(e) => this.setState({remark:e.target.value})} />
                                                                                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.remarkWarning}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        this.state.addingResponse &&
                                                                                            <ButtonLoader />
                                                                                    }
                                                                                    <div className="actionIcons">
                                                                                        <FontAwesomeIcon icon={['fas', 'check']} color="#219653" style={{ marginRight: 5, cursor: 'pointer' }} title="Click to add response" onClick={(e) => this.state.addingResponse ? e.preventDefault() : this.validateResponseDetails()} />
                                                                                        <FontAwesomeIcon icon={['fas', 'times']} color="#EB5757" style={{ cursor: 'pointer' }} title="Click to cancel adding response" onClick={() => this.closeAddCertificateResponse()} />
                                                                                    </div>
                                                                                    {/* <div className="btn submitInputDiv" onClick= {() => this.validateResponse()} disabled={this.state.addingResponse}>
                                                                                    Submit for Review
                                                                                    </div>
                                                                                    <div className="btn cancelInputDiv btn-outline-primary waves-effect">
                                                                                        Cancel
                                                                                    </div> */}
                                                                                </div>
                                                                            }
                                                                            </>
                                                                        }                                                              
                                                                    </div>
                                                                </div>
                                                                <div className="collapseIcon">
                                                                    {
                                                                        this.state.collapsedContentIdArray.includes(content.pointId) ? 
                                                                        <FontAwesomeIcon icon={['fas', 'caret-up']}  style={{ marginRight: 10, cursor: 'pointer' }} onClick={() => this.collapseContent(content)} />
                                                                        :<FontAwesomeIcon icon={['fas', 'caret-down']}  style={{ marginRight: 10, cursor: 'pointer' }} onClick={() => this.collapseContent(content)} />
                                                                    }
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                        }
                                    </div>
                                </div>
                        </div>
                        </>                    
                }                
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
                <br/>
                {
                    this.returnVideoCreation()
                }
            </>
        );
    }
}

export default CertificateDetails;